import { Button, Caption, Title } from '@telegram-apps/telegram-ui';

import { useT } from '../hooks/useT.js';
import styles from './AgeGateSheet.module.css';

/**
 * AgeGateSheet — нижняя шторка 18+ перед первой отправкой вопроса (CANON I2).
 *
 * «Глупый» презентационный компонент: БЕЗ хуков состояния, БЕЗ MainButton —
 * только разметка/стили шторки + два действия через пропы. Своя вёрстка (НЕ
 * Modal кита), вынесена 1-в-1 из AskScreen (`ageBackdrop/ageSheet/ageTitle/
 * ageDesc/ageBtns`), чтобы AskScreen и AskByCodeScreen делили один флоу 18+
 * (решение 4 work-020). Открытие шторки — user-gesture у каждого экрана.
 */
export interface AgeGateSheetProps {
  /** Показывать ли шторку. Не рисуется, если false. */
  open: boolean;
  /** Подтверждение 18+ (user-gesture) → сохранить ack + отправить. */
  onConfirm: () => void;
  /** Отмена — закрыть шторку без отправки. */
  onCancel: () => void;
}

export function AgeGateSheet({ open, onConfirm, onCancel }: AgeGateSheetProps) {
  const t = useT();
  if (!open) return null;
  return (
    <div role="dialog" aria-modal="true" className={styles.ageBackdrop}>
      <div className={styles.ageSheet}>
        <Title level="3" weight="2" className={styles.ageTitle}>
          {t.age_gate_title}
        </Title>
        <Caption level="1" className={styles.ageDesc}>
          {t.age_gate_desc}
        </Caption>
        <div className={styles.ageBtns}>
          <Button size="l" stretched onClick={onConfirm}>
            {t.age_gate_confirm}
          </Button>
          <Button size="l" mode="plain" stretched onClick={onCancel}>
            {t.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
}
